const { getPrefixExceptDefault } = require('./langHandler')

module.exports = function linkResolver(doc) {
    if (doc.type === 'page') {
        const prefix = getPrefixExceptDefault(doc.lang);
        return `/${prefix && `${prefix}/`}${doc.slug}`;
    }
    return '/';
}
